import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { SiShopware } from 'react-icons/si';
import { MdOutlineCancel } from 'react-icons/md';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';

const Sidebar = (parms) => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();

  const profile = parms.profile

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const activeLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg  text-white  text-md m-2';
  const normalLink = 'flex items-center gap-5 pl-4 pt-3 pb-2.5 rounded-lg text-md text-gray-700 dark:text-gray-200 dark:hover:text-black hover:bg-light-gray m-2';

  const links = [
    {
      title: "پیشخوان",
      links: [
        {
          name: "پیشخوان",
          link: "",
        },
      ],
    },
    ((profile.permissions?.includes(1) || profile.permissions?.includes(0)) && {
      title: "عکس ها",
      links: [
        {
          name: "لیست عکس ها",
          link: "pics"
        },
        {
          name: "عکس جدید",
          link: "new-pic"
        }
      ]
    }),
    ((profile.permissions?.includes(9) || profile.permissions?.includes(0)) && {
      title: "روایت ها",
      links: [
        {
          name: "لیست روایت ها",
          link: "comments"
        }
      ]
    }),
    ((profile.permissions?.includes(5) || profile.permissions?.includes(0)) && {
      title: "کاربران",
      links: [
        {
          name: "دسترسی مدیر",
          link: "admins"
        }
      ]
    })
  ];

  return (
    <div className="ml-3 h-screen md:overflow-hidden overflow-auto md:hover:overflow-auto pb-10">
      {activeMenu && (
        <>
          <div className="flex justify-center items-center">
            <Link to="/" onClick={handleCloseSideBar} className="items-center gap-3 ml-3 mt-4 flex text-xl font-extrabold tracking-tight dark:text-white text-slate-900 mr-2">
              <img src='logo.png' style={{width: "130px"}} />
            </Link>
            <TooltipComponent content="Menu" position="BottomCenter">
              <button
                type="button"
                onClick={() => setActiveMenu(!activeMenu)}
                style={{ color: currentColor }}
                className="text-xl rounded-full p-3 hover:bg-light-gray mt-4 block md:hidden"
              >
                <MdOutlineCancel />
              </button>
            </TooltipComponent>
          </div>
          <div className="mt-10 ">
            {links.map((item) => (
              item && <div key={item.title}>
                <p className="text-gray-400 dark:text-gray-400 m-3 mt-4 uppercase">
                  {item.title}
                </p>
                {item.links.map((link) => (
                  <NavLink
                    to={`/${link.link}`}
                    key={link.name}
                    onClick={handleCloseSideBar}
                    style={({ isActive }) => ({
                      backgroundColor: isActive ? currentColor : '',
                    })}
                    className={({ isActive }) => (isActive ? activeLink : normalLink)}
                  >
                    <span className="capitalize mr-3">{link.name}</span>
                  </NavLink>
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
